import {
  REQUEST_PREVIOUSSOS,
  FETCH_PREVIOUSSOS_SUCCESS,
  FETCH_PREVIOUSSOS_FAILURE,
  REQUEST_PREVIOUSSO_DETAIL,
  FETCH_PREVIOUSSO_DETAIL_SUCCESS,
  FETCH_PREVIOUSSO_DETAIL_FAILURE,
  REQUEST_PREVIOUSORDERS,
  FETCH_PREVIOUSORDERS_SUCCESS,
  FETCH_PREVIOUSORDERS_FAILURE,
  SELECT_PREVIOUSORDERS,
  RESET_CURRENT_PREVIOUSORDERS,
  REQUEST_PREVIOUSORDERS_DETAIL,
  FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
  FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
  REQUEST_ADDING_PREVIOUSORDER,
  ADD_PREVIOUSORDER_SUCCESS,
  ADD_PREVIOUSORDER_FAILURE,
  REQUEST_DELETE_PREVIOUSORDER,
  DELETE_PREVIOUSORDER_SUCCESS,
  DELETE_PREVIOUSORDER_FAILURE, FETCH_PREVIOUSSQS_SUCCESS, FETCH_PREVIOUSSQS_FAILURE, REQUEST_PREVIOUSSQ_DETAIL, FETCH_PREVIOUSSQ_DETAIL_SUCCESS, FETCH_PREVIOUSSQ_DETAIL_FAILURE, REQUEST_PREVIOUSSQS,
} from '../actions/type';

const INITIAL_STATE = {
  all: [],
  sqAll: [],
  currentPreviousOrders: null,
  currentPreviousOrdersDetail: null,
  isLoading: false,
  error: null,
  previousOrdersAreLoading: false,
  previousOrdersError: null,
  previousQuotesError: null,
  isCreating: false,
  createError: null,
  created: false,
  isEditing: false,
  editError: null,
  edited: false,
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // PreviousSOs action handlers
    case REQUEST_PREVIOUSSOS:
      return { ...state, error: null, isLoading: true };
    case FETCH_PREVIOUSSOS_SUCCESS:
      return { ...state, SOs: action.payload.data, error: null, isLoading: false };
    case FETCH_PREVIOUSSOS_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      return { ...state, SOs: [], error, isLoading: false };
    }
    case REQUEST_PREVIOUSSQS:
      return { ...state, error: null, isLoading: true };
    case FETCH_PREVIOUSSQS_SUCCESS:
      return { ...state, SQs: action.payload.data, error: null, isLoading: false };
    case FETCH_PREVIOUSSQS_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      return { ...state, SQs: [], error, isLoading: false };
    }
    case REQUEST_PREVIOUSSO_DETAIL:
      return { ...state, error: null, isLoading: true };
    case FETCH_PREVIOUSSO_DETAIL_SUCCESS:
      return { ...state, all: action.payload.data, error: null, isLoading: false };
    case FETCH_PREVIOUSSO_DETAIL_FAILURE:
      const er = action.payload || { message: action.payload.message };
      return { ...state, all: [], previousOrdersError: er, isLoading: false };
      
    case REQUEST_PREVIOUSSQ_DETAIL:
      return { ...state, error: null, isLoading: true };
    case FETCH_PREVIOUSSQ_DETAIL_SUCCESS:
      return { ...state, sqAll: action.payload.data, error: null, isLoading: false };
    case FETCH_PREVIOUSSQ_DETAIL_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return { ...state, sqAll: [], previousQuotesError: error, isLoading: false };
    // PreviousOrders action handlers
    case REQUEST_PREVIOUSORDERS:
      return { ...state, error: null, isLoading: true };
    case FETCH_PREVIOUSORDERS_SUCCESS:
      return { ...state, all: action.payload.data, error: null, isLoading: false };
    case FETCH_PREVIOUSORDERS_FAILURE:
      const err = action.payload || { message: action.payload.message };
      return { ...state, all: [], error: err, isLoading: false };
    case SELECT_PREVIOUSORDERS:
      return { ...state, currentPreviousOrders: action.payload };
    case RESET_CURRENT_PREVIOUSORDERS:
      return { ...state, currentPreviousOrders: null };
    case REQUEST_PREVIOUSORDERS_DETAIL:
      return { ...state, previousOrdersError: null, previousOrdersAreLoading: true };
    case FETCH_PREVIOUSORDERS_DETAIL_SUCCESS: // return list of posts and make loading = false
      return { ...state, currentPreviousOrdersDetail: action.payload.data, previousOrdersError: null, previousOrdersAreLoading: false };
    case FETCH_PREVIOUSORDERS_DETAIL_FAILURE: // return error and make loading = false
      const previousOrdersError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
      return { ...state, all: [], previousOrdersError, previousOrdersAreLoading: false };
    case REQUEST_ADDING_PREVIOUSORDER:
      return { ...state, error: null, isLoading: true };
    case ADD_PREVIOUSORDER_SUCCESS:
      return { ...state, isLoading: false };
    case ADD_PREVIOUSORDER_FAILURE:
      return { ...state, error, isLoading: false };
    case REQUEST_DELETE_PREVIOUSORDER:
      return { ...state, error: null, isLoading: true };
    case DELETE_PREVIOUSORDER_SUCCESS:
      return { ...state, isLoading: false };
    case DELETE_PREVIOUSORDER_FAILURE:
      return { ...state, error, isLoading: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/previousOrders_reducer.jsx